// import { Link } from "react-router-dom";
import { deleteZombie } from "../../utils/api";
import "./wakeButton.css";

// COMPONENTS //
import BrushButton from "../BrushButton";

export default function WakeButton({
    zombie,
    setZombie,
    stopMusic,
    stopSound,
    brushImage,
    brushMode,
    children
}) {

    async function handleWakeUp() {
        if (zombie?._id) {
            await deleteZombie(zombie._id);
            localStorage.removeItem("currentZombieId");
            setZombie({});
        }

        stopMusic();
    }

    return (
            <BrushButton
                className="wake-button"
                to="/"
                onClick={handleWakeUp}
                brushImage={brushImage}
                brushMode={brushMode}
            >
                {children || "Wake Up from this Nightmare"}
            </BrushButton>
    );
}